import { useActivityObject } from '@/data/activity';

const Waiver = ({ activityId }) => {
  const activity = useActivityObject(activityId);

  return (
    <div className="max-w-4xl mx-auto rounded-lg shadow-sm ">
      <div className="bg-[var(--waiver-yellow)] border-2 border-[var(--waiver-red)] p-6 mb-6 text-black">
        <h1 className="text-center text-md font-bold mb-4">
          RELEASE OF LIABILITY, WAIVER OF CLAIMS, ASSUMPTION OF RISKS AND
          INDEMNITY AGREEMENT
        </h1>

        <h2 className="text-center text-sm mb-2">
          (hereinafter referred to as the &quot;Release Agreement&quot;)
        </h2>

        <div className="text-center text-sm font-bold mb-2">
          BY SIGNING THIS RELEASE DOCUMENT YOU WILL WAIVE OR GIVE UP CERTAIN
          LEGAL RIGHTS, INCLUDING THE RIGHT TO SUE FOR NEGLIGENCE, BREACH OF
          CONTRACT OR CLAIM COMPENSATION FOLLOWING AN ACCIDENT
        </div>

        <div className="text-center italic text-sm font-bold mb-2">
          PLEASE READ CAREFULLY!
        </div>

        <div className="text-center italic text-sm">
          This Release Agreement shall apply to all subsequent bookings through
          ProFound Professionals Inc.
        </div>
      </div>

      <div className="mb-6">
        <div className="mb-4 text-sm font-bold">
          <h2 className="inline">TO: </h2>PROFOUND PROFESSIONALS INC.
          (&quot;ProFound&quot;) and its affiliated companies and subsidiaries,
          directors, officers, employees, contractors, instructors, guides,
          coaches, agents, representatives, volunteers, independent contractors,
          subcontractors, sponsors, successors and assigns (hereinafter
          collectively referred to as the &quot;Releasees&quot;).
        </div>
      </div>

      <h2 className="font-bold mb-4">ASSUMPTION OF RISKS</h2>
      <div className="mb-4 text-sm">
        The Releasees are providing personalized coaching in various sports
        including but not limited to mountain biking, skiing and snowboarding
        and{' '}
        {activity.servicesContractStr ||
          '[insert detailed description of services here]'}{' '}
        (the &quot;Services&quot;). I am aware and understand that using the
        Services involves many risks, dangers and hazards including, but not
        limited to, property damage or loss, equipment damage, environmental
        damage, personal injury, and death to myself or a third party, which
        could result from many things including, but not limited to: changing
        weather conditions; travelling across unstable, remote, and dangerous
        terrain; encounters with domestic and wild animals; collisions with
        other persons or objects; negligent first aid; failure to act safely or
        within one&apos;s own ability or to stay within designated areas;
        negligence of other persons; and{' '}
        <strong className="font-bold">
          NEGLIGENCE ON THE PART OF THE RELEASEES. I UNDERSTAND THAT NEGLIGENCE
          INCLUDES FAILURE ON THE PART OF THE RELEASEES TO TAKE REASONABLE STEPS
          TO SAFEGUARD OR PROTECT ME FROM OR WARN ME OF THE RISKS, DANGERS AND
          HAZARDS REFERRED TO ABOVE OR ANY OTHER POTENTIAL DANGERS OR HAZARDS.
        </strong>
      </div>
      <div className="font-bold mb-8 text-sm">
        I ACKNOWLEDGE THAT I AM VOLUNTARILY PARTICIPATING IN THE SERVICES. I
        FREELY ACCEPT AND FULLY ASSUME ALL SUCH RISKS, DANGERS AND HAZARDS AND
        THE POSSIBILITY OF PERSONAL INJURY, DEATH, OR PROPERTY DAMAGE OR LOSS
        RESULTING THEREFROM.
      </div>

      <h2 className="font-bold mb-4">
        RELEASE OF LIABILITY, WAIVER OF CLAIMS AND INDEMNITY AGREEMENT
      </h2>
      <div className="text-sm mb-4">
        In consideration of the Releasees accepting my booking to receive the
        Services, I hereby agree as follows:
      </div>

      <ol className="list-decimal pl-6 mb-2 text-sm space-y-4 bg-[var(--waiver-yellow)] border-2 border-[var(--waiver-red)] p-4 text-black">
        <li>
          <strong>TO WAIVE ANY AND ALL CLAIMS</strong> that I have or may in the
          future have against{' '}
          <strong>THE RELEASEES, and TO RELEASE THE RELEASEES</strong> from any
          and all liability for any loss, damage, expense or injury including
          death that I may suffer, or that my next of kin may suffer, as a
          result of my use of the Services DUE TO ANY CAUSE WHATSOEVER,
          INCLUDING NEGLIGENCE, BREACH OF CONTRACT, OR BREACH OF ANY STATUTORY
          OR OTHER DUTY OF CARE ON THE PART OF THE RELEASEES. I UNDERSTAND THAT
          NEGLIGENCE INCLUDES THE FAILURE ON PART OF THE RELEASEES TO TAKE
          REASONABLE STEPS TO SAFEGUARD OR PROTECT ME FROM OR WARN ME OF THE
          RISKS, DANGERS AND HAZARDS REFERRED TO ABOVE OR ANY OTHER POTENTIAL
          RISKS, DANGERS AND HAZARDS.
        </li>
      </ol>
      <ol className="list-decimal pl-6 mb-4 text-sm space-y-4 p-4" start="2">
        <li>
          TO HOLD HARMLESS AND INDEMNIFY THE RELEASEES from any and all
          liability for any property damage or loss to any third party resulting
          from my use of the Services. I acknowledge that the Releases are not
          responsible for third party products or services;
        </li>
        <li>
          This Release Agreement shall be effective and binding upon my heirs,
          next of kin, executors, administrators, assigns and representatives,
          in the event of my death or incapacity;
        </li>
        <li>
          This Release Agreement and any rights, duties and obligations as
          between the parties to this Release Agreement shall be governed by and
          interpreted solely in accordance with the laws of British Columbia and
          no other jurisdiction; and
        </li>
        <li>
          Any litigation involving the parties to this Release Agreement shall
          be brought solely within British Columbia, and shall be within the
          exclusive jurisdiction of the Courts of British Columbia.
        </li>
      </ol>

      <div className="text-sm mb-8">
        In entering into this Release Agreement, I am not relying upon any oral
        or written representations or statements made by the Releasees with
        respect to the safety of the Services other than what is set forth in
        this Release Agreement.
      </div>

      <div className="text-sm mb-8">
        If any part of this Release Agreement is held to be unenforceable, then
        such provision will be severed from this Release Agreement and all other
        provisions of this Release Agreement will remain in full force and
        effect.
      </div>

      <div className="text-sm mb-8 font-bold">
        BY SIGNING THIS RELEASE AGREEMENT, I ACKNOWLEDGE THAT I HAVE READ AND
        UNDERSTOOD ALL OF THE TERMS AND CONDITIONS OF THIS RELEASE AGREEMENT.
      </div>

      <div className="mb-8">
        <h2 className="font-bold text-center mb-4 underline">
          FOR PARENTS/GUARDIANS OF ANYONE UNDER 19 YEARS OF AGE
        </h2>

        <div className="text-sm mb-4">
          <strong>NOTE:</strong> Any children under 19 years of age who use the
          Services must have this form signed by a parent or guardian.
        </div>

        <div className="text-sm">
          For and on behalf of the child of minority age, by signing where
          indicated below, I hereby certify that I am the parent/guardian with
          legal responsibility for this participant of minority age, and
          acknowledge the risks associated with the use of the Services by the
          child, including, but not limited to personal injury, death, damage or
          loss to personal property, whether or not as a result of my or the
          child&apos;s own negligence, the negligence of third parties, or the
          negligence of the Releasees.{' '}
          <strong>
            I HEREBY CONSENT TO THE USE OF THE SERVICES BY THE MINORITY AGED
            CHILD AND AGREE FOR MYSELF, MY HEIRS, EXECUTORS, ASSIGNS, AND NEXT
            OF KIN, TO RELEASE, INDEMNIFY, AND SAVE HARMLESS THE RELEASEES FROM
            ALL LIABILITIES, HOWSOEVER ARISING, INCIDENT TO THE USE OF THE
            SERVICES BY THE CHILD OF MINORITY AGE.
          </strong>
        </div>
      </div>
    </div>
  );
};

export default Waiver;
